import { Fragment, type ReactNode } from "react";
import { Body2, Subtitle2, XStack } from "@medbillai/ui";
import { useLink } from "@medbillai/navigation/link";
import type { Crumb } from "../../lib/webSections";
export const Breadcrumbs = ({
  trail,
  current,
  trailing
}: {
  trail: Crumb[];
  current?: string;
  trailing?: ReactNode;
}) => <XStack alignItems="center" justifyContent="space-between" gap="$sp2" minHeight="$si5.5" paddingTop="$sp1" paddingHorizontal="$sp3" width="100%" data-sentry-element="XStack" data-sentry-component="Breadcrumbs" data-sentry-source-file="Breadcrumbs.tsx">
    <XStack role="navigation" aria-label="Breadcrumb" alignItems="center" gap="$sp0.75" flexShrink={1} minWidth={0} data-sentry-element="XStack" data-sentry-source-file="Breadcrumbs.tsx">
      {trail.map((crumb, i) => <Fragment key={crumb.href}>
          {i > 0 ? <Separator /> : null}
          <CrumbLink {...crumb} />
        </Fragment>)}
      {current ? <>
          {trail.length > 0 ? <Separator /> : null}
          <Subtitle2 color="$textDefault" numberOfLines={1} aria-current="page">
            {current}
          </Subtitle2>
        </> : null}
    </XStack>
    {trailing}
  </XStack>;
const Separator = () => <Body2 color="$textMuted" aria-hidden data-sentry-element="Body2" data-sentry-component="Separator" data-sentry-source-file="Breadcrumbs.tsx">
    /
  </Body2>;
const CrumbLink = ({
  href,
  label
}: Crumb) => {
  const link = useLink({
    href
  });
  return <Body2 render="a" {...link} color="$textSubtle" flexShrink={0} cursor="pointer" textDecorationLine="none" hoverStyle={{
    textDecorationLine: "underline"
  }} focusVisibleStyle={{
    textDecorationLine: "underline"
  }} data-sentry-element="Body2" data-sentry-component="CrumbLink" data-sentry-source-file="Breadcrumbs.tsx">
      {label}
    </Body2>;
};